import React from 'react';
import PropTypes from 'prop-types';
import { CopyList } from '../../../../components/HOCs/withDragAndDrop';
import RecommendedTypeSelector from './RecommendedTypeSelector';
import PromotionalBannerTypeSelector from './PromotionalBannerTypeSelector';
import Switch from 'react-switch';
import { getTranslation } from '../../../../assets/creator/translations';

const TypeElementsAndOptions = ({ show, type, prepareData, handleDragChange, attachStyleToSvg,recommendedTypeChangeHandler,recommendedTypeCurrent, showFixedElements, toggleShowFixedElements, showSwitchButton, promotionalBannerTypeCurrent, promotionalBannerTypeChangeHandler }) => {
    const mainBodyArray = JSON.parse(localStorage.getItem('onlineCreatorB2B-mainBody'));

    const getRecommendedTypeCurrent = () => {
        if (recommendedTypeCurrent > 15) {
            return recommendedTypeCurrent - 10;
        }
        if (recommendedTypeCurrent > 5 && recommendedTypeCurrent <= 15) {
            return recommendedTypeCurrent + 5;
        }
        return recommendedTypeCurrent;
    };

    const getPromotionalBannerTypeCurrent = () => {
        if (promotionalBannerTypeCurrent > 15) {
            return promotionalBannerTypeCurrent - 10;
        }
        if (promotionalBannerTypeCurrent > 5 && promotionalBannerTypeCurrent <= 15) {
            return promotionalBannerTypeCurrent + 5;
        }
        return promotionalBannerTypeCurrent;
    };

    return show &&
    <div className="element-type__elements">
        <RecommendedTypeSelector
            type={type}
            recommendedTypeChangeHandler={recommendedTypeChangeHandler}
            recommendedTypeCurrent={getRecommendedTypeCurrent()}
            isFrom={"sidebar"}
        />

        <PromotionalBannerTypeSelector
            type={type}
            promotionalBannerTypeChangeHandler={promotionalBannerTypeChangeHandler}
            promotionalBannerTypeCurrent={getPromotionalBannerTypeCurrent()}
            isFrom={"sidebar"}
        />

        <CopyList
            groupName={getGroupName(type)}
            items={prepareData(type)}
            handleDragChange={handleDragChange}
            attachStyleToSvg={attachStyleToSvg}
        />       
        
        {type === 'newsletter' && showSwitchButton && mainBodyArray.find(el => el.isPopup && el.type === 'newsletter') && (
            <label className="switch-container">
                <span>{getTranslation("Sw_ShowNewsletter")}</span>
                <Switch height={20} width={48} onChange={toggleShowFixedElements} checked={showFixedElements} onColor={'#4a5de2'}/> 
            </label>
        )}
        {type === 'popupBanner' && showSwitchButton && mainBodyArray.find(el => el.isPopup && el.type === 'popupBanner') && (
            <label className="switch-container">
                <span>{getTranslation("Sw_ShowBanner")}</span>
                <Switch height={20} width={48} onChange={toggleShowFixedElements} checked={showFixedElements} onColor="#4a5de2" />
            </label>
        )}
        {type === 'widget' && showSwitchButton && (
            <label className="switch-container">
                <span>{getTranslation("Sw_ShowWidget")}</span>
                <Switch height={20} width={48} onChange={toggleShowFixedElements} checked={showFixedElements} onColor={'#4a5de2'}/> 
            </label>
        )}
        
    </div>
};

TypeElementsAndOptions.propTypes = {
    show: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    prepareData: PropTypes.func.isRequired,
    handleDragChange: PropTypes.func.isRequired,
    attachStyleToSvg: PropTypes.func,
    recommendedTypeChangeHandler: PropTypes.func.isRequired,
    recommendedTypeCurrent: PropTypes.number,
    showFixedElements: PropTypes.bool.isRequired,
    toggleShowFixedElements: PropTypes.func.isRequired,
    showSwitchButton: PropTypes.bool.isRequired,
    promotionalBannerTypeCurrent: PropTypes.number,
    promotionalBannerTypeChangeHandler: PropTypes.func.isRequired,
};

const getGroupName = (elementType) => {
    if (elementType === 'header' || elementType === 'footer') {
        return elementType;
    }
    return 'body';
};

export default TypeElementsAndOptions;